/**
 * @fileoverview 단일 채널 정보를 조회합니다.
 * 단, 채널에 종속된 채팅 메시지를 반환하지 않습니다.
 * 채널에 종속된 채팅 메시지가 필요하다면 getMessages 함수를 사용해야 합니다.
 */
import { GetChannelRequest } from "@daangn/idl/rocketchat/api/api";
import { isNil } from "lodash";
import { sendRocketchatRequestWithPromise } from "~/rocketchat/rocketChatClient";
import type { ChannelID, ResourceType } from "~/rocketchat/types";
import type { User } from "~/rocketchat/user/user.entity";
import {
  getNormalizedChannel,
  getNormalizedChannelById,
} from "../channelNormalizer";

type GetChannelParams = {
  channelId: ChannelID;
};
export async function getChannel(
  { channelId }: GetChannelParams,
  socket: WebSocket,
) {
  const response = await sendRocketchatRequestWithPromise({
    chatRequest: {
      get_channel: GetChannelRequest.create({
        channel_id: channelId,
      }),
      name: "GetChannelRequest",
    },
    socket,
  });

  const channel = response.get_channel?.channel;
  if (isNil(channel)) {
    throw new Error("getChannel: channel is nil");
  }

  const normalizedChannel = getNormalizedChannel({ channel });
  const channelEntity = getNormalizedChannelById({
    channelId: normalizedChannel.result ?? channel.id,
    normalizedData: normalizedChannel,
  });

  return {
    channel: channelEntity,
    raw: channel,
    users: normalizedChannel.entities.User,
  };
}

type GetChannelForceParams = {
  resourceType: ResourceType;
  articleDbId: string;
  sender: User;
  receiver: User;
};
export async function getChannelForce(
  { resourceType, articleDbId, sender, receiver }: GetChannelForceParams,
  socket: WebSocket,
) {
  const response = await sendRocketchatRequestWithPromise({
    chatRequest: {
      get_channel: GetChannelRequest.create({
        channel_id: "",
        force: true,
        receiver,
        resource_id: articleDbId,
        resource_type: resourceType,
        sender,
        with_last_message: true,
      }),
      name: "GetChannelRequest",
    },
    socket,
  });
  const channel = response.get_channel?.channel;
  if (isNil(channel)) {
    throw new Error("getChannel: channel is nil");
  }
  const normalizedChannel = getNormalizedChannel({ channel });
  const channelEntity = getNormalizedChannelById({
    channelId: normalizedChannel.result ?? channel.id,
    normalizedData: normalizedChannel,
  });

  return {
    channel: channelEntity,
    raw: channel,
    users: normalizedChannel.entities.User,
  };
}
